import { useNeedsReview } from "./useMyRejectedQaTasks";

/** Number of flagged QA tasks (OOS and Coverage Beta) the logged-in user still needs to review. */
export function useNeedsReviewCount(): number {
  // Only the count is needed, so fetch a single task per type.
  return useNeedsReview("me", 1).count;
}
